import doNothing from '#helpers/api/doNothing.js'
import i18n from '#helpers/i18n/i18n.js'
import errorBag from '#helpers/logging/errorBag.js'
import Logger from '#helpers/logging/Logger.js'
import swal from '#helpers/sweetalert/sweetalert.js'
import { CanceledError } from 'axios'

/**
 * @param {CanceledError | object} error - The error to handle
 * @param {object} error.response - A response object of the error
 * @param {string} error.message - A message for the error
 * @param {object} error.response.data - Any data for the error
 * @returns {object} - An empty object
 */
export default function handleApiObject(error) {
	if (error instanceof CanceledError) {
		return {}
	}
	Logger.error('return with object', error)

	swal({
		title: i18n.global.t('alerts.error'),
		icon: 'error',
		content: error?.response?.data ? errorBag(error.response.data) : error?.message,
		buttons: false,
	}).catch(doNothing)

	return {}
}
